export default __webpack_public_path__ + "static/media/slide-2.1b4e40d6.jpg";